import { Component, Injector, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  SnackbarComponent,
  ViewModalComponent,
} from 'projects/kiosk-app/src/app/components';

@Component({
  selector: 'app-view-email',
  templateUrl: './view-email.component.html',
  styleUrls: ['./view-email.component.scss'],
})
export class ViewEmailComponent extends ViewModalComponent implements OnInit {
  public emails: any[] = [];

  constructor(private readonly snackBar: MatSnackBar, injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.currentViewModalType = 'email';
    this.emails = this.cloneProfile.emails;
  }

//original
  public getMainEmailIndex1() {
    if (this.profileService.isUcSecondVersion) {
      const { a_PrimaryEmail, a_HomeEmail } = this.profileService.playerProfile;
      const emailIndex = this.emails.findIndex(
        (e) => e.type === a_PrimaryEmail.type || e.type === a_HomeEmail.type
      );
      return emailIndex;
    }
    return this.emails.findIndex((e) => e.location === 'Main Email');
  }

  public getMainEmailIndex(): number { // returning a number - not nullable anymore
  if (!Array.isArray(this.emails)) { // this this.emails should be at least an array. Protects against undefined or null, so no errors on this.emails.length
    this.emails = [];
  }

  if (this.emails.length === 0) {
    // Add default email entry - If no email objects exist in the array, we inject a default one
    const defaultEmail = { 
      address: "",
      id: "",
      primary: "",
      sendTo: "true",
    };

    this.emails.push(defaultEmail);

    // Also update playerProfile if needed or  missing 
    if (!this.profileService.playerProfile) {
      this.profileService.playerProfile = {} as any;
    }

    //Updates both a_PrimaryEmail and a_HomeEmail objects to point to the default.
    this.profileService.playerProfile.a_PrimaryEmail = { ...defaultEmail, type: 'Primary' };
    this.profileService.playerProfile.a_HomeEmail = { ...defaultEmail, type: 'Home' };
  }

  if (this.profileService.isUcSecondVersion) {
    const { a_PrimaryEmail, a_HomeEmail } = this.profileService.playerProfile || {}; // use this, no undefined
    const emailIndex = this.emails.findIndex(
      (e) => e.type === a_PrimaryEmail?.type || e.type === a_HomeEmail?.type
    );
    return emailIndex !== -1 ? emailIndex : 0;
  }

  //If no match found, returns 0 (the fallback default index) instead of null
  const index = this.emails.findIndex((e) => e.location === 'Main Email');
  return index !== -1 ? index : 0;
}


  public setOptOutValue() {
    this.emails[this.getMainEmailIndex()].sendTo === 'true'
      ? (this.emails[this.getMainEmailIndex()].sendTo = 'false')
      : (this.emails[this.getMainEmailIndex()].sendTo = 'true');
  }

  override updateFields(): void {
    this.cloneProfile.emails = this.emails;
  }

  public get isValidEmail(): boolean {
    const email = this.emails[this.getMainEmailIndex()].address;

    const regexLocal = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const regexBuilder = new RegExp(
      eval(this.tabData?.templateConfig?.email?.regex)
    );
    return regexBuilder ? regexBuilder.test(email) : regexLocal.test(email);
  }

  public checkValidate(): void {
    const value = this.emails[this.getMainEmailIndex()]?.address;
    if (value) {
      if (!this.isValidEmail) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          panelClass: 'error',
          duration: 5000,
          horizontalPosition: 'end',
          data: {
            type: 'error',
            message: 'Please enter a valid email address',
          },
        });
        return;
      }
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        panelClass: 'error',
        duration: 5000,
        horizontalPosition: 'end',
        data: {
          type: 'error',
          message: 'Please enter an email address',
        },
      });
      return;
    }

    this.closeModal(true);
  }
}
